export default "__VITE_ASSET__DDQAkDSZ__"